import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';
import { PaymentGatewayModel } from '../model/interfaces/paymentGateway.interface';
import { MappingPaymentAttribute } from '../model/classes/paymentGateway.class';

@Injectable()
export class PaymentGatewayService {
    private paymentUrl = 'api/paymentGateways';

    constructor(private sxHttp: SxHttpService) { }

    getList(systemCode: string): Observable<TemplateListadoItem[]> {
        return this.sxHttp.get(this.paymentUrl + '/' + systemCode).map(response => {
            const outputs = response.json().data;
            return outputs.map(output => {
                return {
                    id: output.pgCode,
                    imagen: output.urlImage,
                    titulo: output.outputCode,
                    subtitulo: output.description,
                };
            });
        });
    }

    get(systemCode: string, pGCode: string): Observable<PaymentGatewayModel> {
        const url = `${this.paymentUrl}/${systemCode}/${pGCode}`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data)
            .map(response => {
                if (response) {
                    const deserializedSettings = JSON.parse(response.settings);
                    response.settings = deserializedSettings;
                }
                return response as PaymentGatewayModel;
            });
    }

    create(output: PaymentGatewayModel): Promise<PaymentGatewayModel> {
        return this.sxHttp
            .post(this.paymentUrl, output)
            .toPromise()
            .then(response => response.json().data as PaymentGatewayModel);
    }

    edit(systemCode: string, pGCode: string, payment: PaymentGatewayModel): Promise<PaymentGatewayModel> {
        delete payment['completeness'];
        const url = `${this.paymentUrl}/${systemCode}/${pGCode}`;

        return this.sxHttp
            .put(url, payment)
            .toPromise()
            .then(response => response.json().data as PaymentGatewayModel);
    }

    delete(systemCode: string, pgCode: string): Observable<any> {
        return this.sxHttp
            .delete(this.paymentUrl+'/'+systemCode+'/'+pgCode)
            .map(result => result.json().data);
    }

    scanMapping(systemCode: string, businessCode: string, productCode: string,kind:string,pgcode:string): Observable<MappingPaymentAttribute[]> {
        const url = `${this.paymentUrl}/${systemCode}/${businessCode}/${productCode}/${kind}/${pgcode}`;
        return this.sxHttp
            .get(url)
            .map(result => result.json().data);
    }

    getAttributes(systemCode: string, pgcode: string): Observable<DesignerSelectItem[]> {
        const url = `${this.paymentUrl}/GetAttributes/${systemCode}/${pgcode}`;
        return this.sxHttp
            .get(url)
            .map(result => result.json().data as DesignerSelectItem[]);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/payment.gateways.service.ts